// import { addObjectEntriesByKeys } from '../helpers/objectTypes';
import gameObjectTypes, { gameObjectTypesDefault } from './gameObjectTypes';

export const regionNames = {
    REGION_1: 'region-1',
    REGION_2: 'region-2',
    REGION_3: 'region-3',
    REGION_4: 'region-4',
    REGION_5: 'region-5',
    REGION_6: 'region-6'
};

export default [
    {
        name: regionNames.REGION_1,
        startAtDistance: 0,
        objects: [
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.BUSH_1_LEFT,
            gameObjectTypes.BUSH_1_RIGHT,
            gameObjectTypes.SIGN_60_LEFT,
            gameObjectTypes.SIGN_60_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.BUSH_2_LEFT
            },
            {
                type: gameObjectTypes.REGION_1_SIGN
            },
            {
                type: gameObjectTypes.REGION_1_BUILDING
            }
        ]
    },
    {
        name: regionNames.REGION_2,
        startAtDistance: 60,
        objects: [
            gameObjectTypes.SPRUCE_1_LEFT,
            gameObjectTypes.SPRUCE_1_RIGHT,
            gameObjectTypes.SIGN_MOOSE_LEFT,
            gameObjectTypes.SIGN_MOOSE_RIGHT,
            gameObjectTypes.MOOSE_LEFT,
            gameObjectTypes.MOOSE_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_2_SIGN
            },
            {
                type: gameObjectTypes.REGION_LAKE
            }
        ]
    },
    {
        name: regionNames.REGION_3,
        startAtDistance: 100,
        objects: [
            gameObjectTypes.TREE_1_LEFT,
            gameObjectTypes.TREE_1_RIGHT,
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.BUSH_1_LEFT,
            gameObjectTypes.BUSH_1_RIGHT,
            gameObjectTypes.SIGN_60_LEFT,
            gameObjectTypes.SIGN_60_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_3_SIGN
            },
            {
                type: gameObjectTypes.REGION_3_BUILDING
            }
        ]
    },
    {
        name: regionNames.REGION_4,
        startAtDistance: 170 * 3,
        objects: [
            gameObjectTypes.SIGN_MOOSE_LEFT,
            gameObjectTypes.SIGN_MOOSE_RIGHT,
            gameObjectTypes.MOOSE_LEFT,
            gameObjectTypes.MOOSE_RIGHT,
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.ROCK_1_LEFT,
            gameObjectTypes.ROCK_1_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_4_SIGN
            },
            {
                type: gameObjectTypes.REGION_LAKE
            },
            {
                type: gameObjectTypes.BUSH_3_LEFT
            },
            {
                type: gameObjectTypes.BUSH_3_RIGHT
            }
        ]
    },
    {
        name: regionNames.REGION_5,
        startAtDistance: 170 * 4,
        objects: [
            gameObjectTypes.SIGN_60_LEFT,
            gameObjectTypes.SIGN_60_RIGHT,
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.BUSH_1_LEFT,
            gameObjectTypes.BUSH_1_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_5_SIGN
            },
            {
                type: gameObjectTypes.REGION_5_BUILDING
            },
            {
                type: gameObjectTypes.BUSH_2_LEFT
            }
        ]
    },
    {
        name: regionNames.REGION_6,
        startAtDistance: 170 * 5,
        objects: [
            gameObjectTypes.HUMMOCK_1_LEFT,
            gameObjectTypes.HUMMOCK_1_RIGHT,
            gameObjectTypes.SPRUCE_2_LEFT,
            gameObjectTypes.SPRUCE_2_RIGHT,
            ...Object.values(gameObjectTypesDefault)
        ],
        welcomeObjects: [
            {
                type: gameObjectTypes.REGION_6_SIGN
            }
        ]
    }
];
